import React from "react";
import ProfileCard from "../components/ProfileCard";
import profilesData from "../data/profiles.json";

const NAM: React.FC = () => {
  const namModels = profilesData.filter((profile) => profile.type === "nam");

  return (
    <div className="container mx-auto p-8 text-white max-w-[1280px]">
      <section className="py-5 text-center">
        <h1 className=" text-4xl md:text-6xl  lg:text-8xl font-bold gradient-text-tonex mb-0 lg:mb-20">
          NAM Models
        </h1>
        <p className="opacity-70 mt-4 text-xl lg:text-xl">
          <b>
            Experience Unprecedented Amp Realism with Premium Neural Amp Modeler
            (NAM) Profiles.{" "}
          </b>
          Dive into our collection of meticulously trained NAM captures,
          delivering the authentic tones of legendary amplifiers. Start with our
          free Marshall and Kitty Hawk NAM profiles, and then explore our
          premium offerings, including the coveted SRV tone and the iconic Mesa
          Boogie Mark IIA. Discover the next level of amp modeling fidelity and
          bring the sound of your favorite amps to your digital setup with our
          high-quality NAM profiles.
        </p>
      </section>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
        {namModels.map((model) => (
          <ProfileCard key={model.id} profile={model} />
        ))}
      </div>{" "}
      <section className="opacity-70 text-xl lg:text-xl my-20 flex gap-4 flex-col text-center items-center">
        <h1 className=" text-xl md:text-2xl  lg:text-2xl font-bold gradient-text ">
          NAM Metadata Editor
        </h1>
        <p>
          For custom NAM file creators: Utilize this online editor to perform
          batch metadata and filename modifications efficiently.
        </p>
        <div className="flex justify-center">
          {" "}
          {/* Removed w-full */}
          <a
            href="/nam-editor/"
            target="_blank"
            aria-label="nam metadata editor"
            rel="noopener noreferrer"
            className="py-2 px-8 rounded-full text-center transition-colors bg-opacity-70 bg-green-500 hover:bg-green-900 inline-block"
          >
            Learn more
          </a>
        </div>
      </section>
      <section className="mt-8  text-center max-w-[800px] mx-auto">
        <p className="text-sm opacity-50 ">
          PWC Profiles is not affiliated, associated, or in any way connected
          with the owners of the amplifier brands mentioned. All trademarks and
          copyrights belong to their respective owners. The use of these names
          is purely for descriptive and comparative purposes in the context of
          Kemper Profiles and Tonex models, which aim to replicate the sonic
          qualities of the original amplifiers.
        </p>
      </section>
    </div>
  );
};

export default NAM;
